module.exports = __webpack_public_path__ + "media/loader.241c3e8c.webm";